module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"PRODUCT":"Product","SERVICE":"Service","HYBRID":"Hybrid"},"de":{"PRODUCT":"Produkt","SERVICE":"Dienstleistung","HYBRID":"Hybrid"}}')
  delete Component.options._Ctor
}
